// default middlewares
// @AUTHOR CAIHUAZHI <huazhi.chz@alibaba-inc.com>
// @CREATE 2023/11/27 18:20
import { fetcher } from './abilities/fetcher';
import { sleep, logger } from './utils';
/** 默认的前置处理 */
export async function defaultPreHandler(ctx) {
    var _a;
    // fillOptions
    ctx.headers = ctx.headers || {};
    ctx.meta = ctx.meta || {};
    // delay
    if ((_a = ctx.meta) === null || _a === void 0 ? void 0 : _a.delay) {
        await sleep(ctx.meta.delay);
    }
    await ctx.next();
}
/**
 * 打印日志
 */
export async function printLogger(ctx) {
    var _a;
    const begin = performance.now();
    logger.debug(`>> ${ctx.method || 'GET'} ${ctx.api}`, ctx.data);
    await ctx.next();
    const duration = performance.now() - begin;
    const logFn = ((_a = ctx.response) === null || _a === void 0 ? void 0 : _a.success) === false ? 'warn' : 'info';
    logger[logFn](`<< ${ctx.method || 'GET'} ${ctx.api} ${duration}ms`, ctx.response);
}
/**
 * 请求适配器
 */
export async function adapter(ctx) {
    const fn = ctx.executor || fetcher;
    // 如果已经有数据，则跳过数据请求
    if (ctx.response === undefined) {
        ctx.response = await fn(ctx.api, ctx);
    }
    return await ctx.next();
}
